import {Checkbox} from "@mui/material";
import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../../stores";

export const RootSelectionBox: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores()
    const reviewPageSelectionController = categorizationReviewStore.reviewPageController.reviewPageSelectionController;
    return <Checkbox
        className="root-selection-component"
        checked={reviewPageSelectionController.selectionState === 'some' || reviewPageSelectionController.selectionState === 'all'}
        onClick={() => reviewPageSelectionController.onClickToggleAllSelected()}
        indeterminate={reviewPageSelectionController.selectionState === 'some'}
        disabled={reviewPageSelectionController.nTotal === 0}
    />
})
